import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IModuleInfo {
  IdProduto: number
  Nome: string
}

interface IUserState {
  currentUser?: any
  modules: IModuleInfo[]
}

const initialState: IUserState = {
  currentUser: undefined,
  modules: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUserState(state, action: PayloadAction<any>) {
      state.currentUser = action.payload
    },
    setCurrentUserModulesState(state, action: PayloadAction<IModuleInfo[]>) {
      state.modules = action.payload
    }
  },
});

export const {
  setCurrentUserState,
  setCurrentUserModulesState
} = userSlice.actions;

export const userReducer = userSlice.reducer;
